import { AxiosRequestConfig } from "axios";

export const putEditApplicationConfig = (ApplicationId: string): AxiosRequestConfig => {
  return {
    method: "put",
    url: `/application/${ApplicationId}/data`,
  };
};
